import { generateHash } from '../common'
import { generateWebGLFingerprint } from './web-gl'
// import { getIpFingerprint } from './ip'
import { getScreenFingerprint } from './screen'
import { getAudioFingerprint } from './audio'

export async function generateDeviceFingerprint() {
  const webGLFingerprint = generateWebGLFingerprint()
  console.log('webGLFingerprint', webGLFingerprint)
  // const ipFingerprint = await getIpFingerprint()
  // console.log('ipFingerprint', ipFingerprint)
  const screenFingerprint = getScreenFingerprint()
  console.log('screenFingerprint', screenFingerprint)
  const audioFingerprint = getAudioFingerprint()
  console.log('audioFingerprint', audioFingerprint)

  return generateHash({
    ...webGLFingerprint,
    // ...ipFingerprint,
    ...screenFingerprint,
    ...audioFingerprint
  })
}
